import { jsPDF } from "jspdf";

import { loadPdfTemplate } from "@/lib/brandAssets";
import { formatCurrency } from "@/lib/currency";

export async function downloadReportPdf(report, settings) {
  const money = (value) => formatCurrency(value, settings);
  const pdf = new jsPDF({ unit: "mm", format: "a4" });
  let template = null;
  try {
    template = await loadPdfTemplate();
  } catch (error) {
    console.warn("El PDF se generó sin plantilla institucional.", error);
  }
  const paintTemplate = () => {
    if (template) pdf.addImage(template, "PNG", 0, 0, 210, 297);
  };
  paintTemplate();
  pdf.setTextColor(21, 74, 116);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(18);
  pdf.text("REPORTE COMERCIAL", 18, 70);
  pdf.setTextColor(83, 105, 120);
  pdf.setFontSize(9);
  pdf.setFont("helvetica", "normal");
  pdf.text(`Desde: ${report.periodo.desde || "Inicio"}`, 18, 78);
  pdf.text(`Hasta: ${report.periodo.hasta || "Hoy"}`, 75, 78);
  pdf.setFillColor(238, 247, 252);
  pdf.roundedRect(18, 88, 174, 28, 3, 3, "F");
  pdf.setTextColor(21, 74, 116);
  pdf.setFontSize(10);
  pdf.text(`Ventas concretadas: ${report.resumen.cotizaciones}`, 24, 99);
  pdf.text(`Monto concretado: ${money(report.resumen.monto_total)}`, 86, 99);
  pdf.text(`Descuentos: ${money(report.resumen.descuentos)}`, 24, 109);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(13);
  pdf.text("Detalle de ventas por vendedor", 18, 132);
  const tableHeader = (headerY) => {
    pdf.setFontSize(8);
    pdf.setFillColor(21, 74, 116);
    pdf.rect(18, headerY, 174, 8, "F");
    pdf.setTextColor(255, 255, 255);
    pdf.setFont("helvetica", "bold");
    pdf.text("VENDEDOR", 22, headerY + 5.5);
    pdf.text("COTIZACIONES", 70, headerY + 5.5);
    pdf.text("MONTO", 108, headerY + 5.5);
    pdf.text("INICIAL PROM.", 154, headerY + 5.5);
    pdf.setFont("helvetica", "normal");
  };
  tableHeader(138);
  let y = 151;
  report.por_vendedor.forEach((seller) => {
    if (y > 270) {
      pdf.addPage();
      paintTemplate();
      pdf.setTextColor(21, 74, 116);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.text("DETALLE POR VENDEDOR", 18, 70);
      tableHeader(78);
      y = 91;
    }
    pdf.setTextColor(35, 52, 66);
    pdf.text(seller.vendedor || "Sin asignar", 18, y);
    pdf.text(String(seller.cotizaciones), 78, y);
    pdf.text(money(seller.monto_total), 108, y);
    pdf.text(money(seller.inicial_promedio), 154, y);
    pdf.setDrawColor(224, 231, 237);
    pdf.line(18, y + 3, 192, y + 3);
    y += 9;
  });
  const reservations = report.reservas || { cantidad: 0, monto_total: 0, detalle: [] };
  if (y > 238) {
    pdf.addPage();
    paintTemplate();
    y = 76;
  }
  pdf.setFillColor(238, 247, 252);
  pdf.roundedRect(18, y + 8, 174, 24, 3, 3, "F");
  pdf.setTextColor(21, 74, 116);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(12);
  pdf.text("RESERVAS ACTIVAS", 24, y + 18);
  pdf.setFontSize(9);
  pdf.text(`${reservations.cantidad} reservas`, 24, y + 27);
  pdf.text(`Monto reservado: ${money(reservations.monto_total)}`, 92, y + 27);
  pdf.save("reporte-comercial-puerto-santa-cruz.pdf");
}
